import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export default function LoadProfileLaneHistoryScorecardItem({ item }) {
  return (
    <Box sx={{
      padding: "6px 12px",
      backgroundColor: "white_opacity.100",
      margin: "0 12px 12px 0",
      width: "150px",
      border: "1px solid",
      borderColor: "black_opacity.10"
    }}>
      <Typography variant="h2" color="black_opacity.100">
        {item.value}
      </Typography>
      <Typography variant="body2" color="black_opacity.80">
        {item.label}
      </Typography>
    </Box>
  );
}

LoadProfileLaneHistoryScorecardItem.propTypes = {
  item: PropTypes.object.isRequired
};